// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ox-1";
export var stateContainer = "_ox-0";